import React  from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";


const SignUp = ({handlerLogin}) => {

  const handlerCreate = (e) => {
    e.preventDefault()
    let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
  width=600,height=850,left=0,top=0`;
    window.open('https://all-access.wax.io/', 'wax', params);
  }
  
  return (
    <>
      <div className="actions-title">Sign in using your WAX Cloud Wallet & Redeem Code</div>
      <div className="continue">
        <button onClick={handlerLogin}>Sign In</button>
        <button className="full" onClick={handlerCreate}>Create Account</button>
      </div>
    </>
  )
}

SignUp.propTypes = {
  handlerLogin: PropTypes.func.isRequired
}

export default SignUp;